import React from 'react';
import '../../pages/List.css';
import '../../App.css';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper
} from '@material-ui/core';
import {
  createStyles,
  makeStyles,
  Theme,
  withStyles
} from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';
import { EMPLOYEE_TYPE } from '../../const/Const';
import { useRecoilState } from 'recoil';
import { mainBlueColor } from '../../GlobalState';
import { TUserDetails } from '../../types/UserList';

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white
  },
  body: {
    fontSize: 16
  }
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    height: 60,
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
      '&:hover': {
        backgroundColor: '#CFCFCF'
      }
    }
  }
}))(TableRow);

type Tprops = {
  outsidePartners: TUserDetails[];
  partnerId: number;
};

export const PartnerList: React.FC<Tprops> = (props: Tprops) => {
  const { outsidePartners, partnerId } = props;
  const [mainColor] = useRecoilState(mainBlueColor);
  const classes = useStyles({ mainColor: mainColor });
  const history = useHistory();

  return (
    <TableContainer component={Paper}>
      <Table className={classes.main} aria-label='customized table'>
        <TableHead>
          <TableRow>
            <StyledTableCell className={classes.table} align='center'>
              氏名
            </StyledTableCell>
            <StyledTableCell className={classes.table} align='center'>
              メールアドレス
            </StyledTableCell>
            <StyledTableCell className={classes.table} align='center'>
              電話番号
            </StyledTableCell>
            <StyledTableCell className={classes.table} align='center'>
              社員グループ名
            </StyledTableCell>
            <StyledTableCell className={classes.table} align='center'>
              最終ログイン
            </StyledTableCell>
            <StyledTableCell className={classes.table} align='center'>
              ステータス
            </StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {outsidePartners &&
            outsidePartners.map((row: any, index: number) => (
              <StyledTableRow key={row.id} className='click_table_row'>
                <StyledTableCell
                  className={classes.table1}
                  style={{ minWidth: 100 }}
                  align='center'
                  onClick={() => {
                    history.push(`/employee-masters/${row.id}/edit`, {
                      partnerId: partnerId,
                      employeeId: row.id,
                      actionType: 'edit',
                      employeeType: EMPLOYEE_TYPE['OUTSIDE_PARTNER']
                    });
                    window.scrollTo(0, 0);
                  }}
                >
                  {row.name}
                </StyledTableCell>
                <StyledTableCell
                  className={classes.table1}
                  style={{ minWidth: 100 }}
                  align='center'
                  onClick={() => {
                    history.push(`/employee-masters/${row.id}/edit`, {
                      partnerId: partnerId,
                      employeeId: row.id,
                      actionType: 'edit',
                      employeeType: EMPLOYEE_TYPE['OUTSIDE_PARTNER']
                    });
                    window.scrollTo(0, 0);
                  }}
                >
                  {row.email}
                </StyledTableCell>
                <StyledTableCell
                  className={classes.table1}
                  style={{ minWidth: 100 }}
                  align='center'
                  onClick={() => {
                    history.push(`/employee-masters/${row.id}/edit`, {
                      partnerId: partnerId,
                      employeeId: row.id,
                      actionType: 'edit',
                      employeeType: EMPLOYEE_TYPE['OUTSIDE_PARTNER']
                    });
                    window.scrollTo(0, 0);
                  }}
                >
                  {row.tel}
                </StyledTableCell>
                <StyledTableCell
                  className={classes.table1}
                  style={{ minWidth: 100 }}
                  align='center'
                  onClick={() => {
                    history.push(`/employee-masters/${row.id}/edit`, {
                      partnerId: partnerId,
                      employeeId: row.id,
                      actionType: 'edit',
                      employeeType: EMPLOYEE_TYPE['OUTSIDE_PARTNER']
                    });
                    window.scrollTo(0, 0);
                  }}
                >
                  {row.groups}
                </StyledTableCell>
                <StyledTableCell
                  className={classes.table1}
                  style={{ minWidth: 100 }}
                  align='center'
                  onClick={() => {
                    history.push(`/employee-masters/${row.id}/edit`, {
                      partnerId: partnerId,
                      employeeId: row.id,
                      actionType: 'edit',
                      employeeType: EMPLOYEE_TYPE['OUTSIDE_PARTNER']
                    });
                    window.scrollTo(0, 0);
                  }}
                >
                  {row.last_login}
                </StyledTableCell>
                <StyledTableCell
                  className={classes.table1}
                  style={{ minWidth: 100 }}
                  align='center'
                  onClick={() => {
                    history.push(`/employee-masters/${row.id}/edit`, {
                      partnerId: partnerId,
                      employeeId: row.id,
                      actionType: 'edit',
                      employeeType: EMPLOYEE_TYPE['OUTSIDE_PARTNER']
                    });
                    window.scrollTo(0, 0);
                  }}
                >
                  {row.enrollment_status}
                </StyledTableCell>
              </StyledTableRow>
            ))}
        </TableBody>
      </Table>
      {outsidePartners && outsidePartners.length === 0 && (
        <div className={classes.container}>データがありません</div>
      )}
    </TableContainer>
  );
};

type TStyleProps = {
  mainColor: string;
};

export const useStyles = makeStyles<Theme, TStyleProps>((theme: Theme) =>
  createStyles({
    container: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: 60
    },
    table: {
      backgroundColor: props => props.mainColor,
      color: '#FFFFFF',
      padding: 8,
      fontSize: 16,
      height: 60
    },
    input: {
      borderColor: '#CCCCCC',
      padding: 5,
      margin: 10
    },
    table1: {
      padding: 8
    }
  })
);
